<template>
  <VModal ref="modal" @modal:hidden="$emit('hide')" disable-backdrop-click>
    <div class="w-full max-w-2xl mx-auto">
      <BaseCard @click.stop>
        <BaseCardBody> Acc order payment method mapping </BaseCardBody>
        <BaseCardBody clear-padding>
          <AccOrderPaymentMethodMappingForm :soft-one-service-id="thirdPartyServiceId" />
        </BaseCardBody>
        <BaseCardBody>
          <BaseButton primary @click="$refs.modal.close()"> Close </BaseButton>
        </BaseCardBody>
      </BaseCard>
    </div>
  </VModal>
</template>

<script>
import AccOrderPaymentMethodMappingForm from './AccOrderPaymentMethodMappingForm.vue';

export default {
  components: {
    AccOrderPaymentMethodMappingForm,
  },
  props: {
    thirdPartyServiceId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      lockCreate: false,
    };
  },
  computed: {
    thirdPartyService() {
      return this.$store.state.entities.thirdPartyServices.byId[this.thirdPartyServiceId] || null;
    },
  },
};
</script>
